<template>
  <component :is="tag">
    <!-- correctAnswerCell はT9-3のみで使われているCSSクラスのため、
    その他の箇所からの呼び出し時は、ついていても影響を及ぼさない   -->
    <div class="correctAnswerCell">
      <markdown-view-teacher :rawText="correctAnswer"></markdown-view-teacher>
    </div>
  </component>
</template>

<script setup lang="ts">
  import {ref, computed} from "vue";
  import {QUIZTYPE} from "@/consts/answer_column";
  import {CHOICESLABEL} from "@/consts/choicesLabel";

  const props = withDefaults(
    defineProps<{
      answerFormat: number
      choicesLabel?: number
      correctAnswers: any
      tag?: 'td' | 'th'
    }>(),
    { tag: 'td' }
  )

  const prefixRandomOrder = ref("【順不同】")
  const suffixHasAnotherAnswers = ref("（別解あり）")
  const separator = ref("／")
  const separatorSorting = ref("⇒")

  const correctAnswer = computed(() => {
    // 画面表示用の「正答」を返す
    const answerFormat: number = Number(props.answerFormat);
    const choicesLabel: number = Number(props.choicesLabel);
    const answers = props.correctAnswers

    if (QUIZTYPE.DESCRIPTION === answerFormat) {
      // 1: 記述式
      const primaryAnswer = answers[0]
      const suffix = getSuffixIfAnotherAnswersExistsIn(answers)
      return `${primaryAnswer}${suffix}`
    }
    if (QUIZTYPE.SELECT === answerFormat) {
      // 2: 選択式
      const correctAnswers = getCorrectAnswersWithChoicesLabel(
        choicesLabel,
        answers
      )
      return correctAnswers.join(separator.value)
    }
    if (QUIZTYPE.SORTING === answerFormat) {
      // 3: 並び替え
      const correctAnswers = getCorrectAnswersWithChoicesLabel(
        choicesLabel,
        answers
      )
      return correctAnswers.join(separatorSorting.value)
    }
    if (QUIZTYPE.NO_ANSWER === answerFormat) {
      // 4: 解答欄なし
      // ref. NRF-3448 解答欄が「解答欄なし」（answer_format=4）の場合のT9-3の表示仕様を変えてほしい
      return "（解答・解説をご覧ください）"
    }

    if (QUIZTYPE.WRITTEN_RANDOM_ORDER === answerFormat) {
      // 5: 順不問記述式
      let correctAnswers = [];
      for (const answerList of answers) {
        const primaryAnswer = answerList[0]
        const suffix = getSuffixIfAnotherAnswersExistsIn(answerList)
        correctAnswers.push(`${primaryAnswer}${suffix}`)
      }
      return `${prefixRandomOrder.value}${correctAnswers.join(separator.value)}`
    }

    if (QUIZTYPE.MULTIPLE_CHOICE_RANDOM_ORDER === answerFormat) {
      // 6: 順不問選択式
      const correctAnswers = getCorrectAnswersWithChoicesLabel(
        choicesLabel,
        answers
      )
      return `${prefixRandomOrder.value}${correctAnswers.join(separator.value)}`
    }

    // 解答形式不正の場合 (基本ない) は空文字を返す
    return ""
  })

  function getSuffixIfAnotherAnswersExistsIn(answers: string[]): string {
    return answers.length > 1  ? suffixHasAnotherAnswers.value : ""
  }

  function getCorrectAnswersWithChoicesLabel(
    choicesLabel: number,
    answers: { answer: string, answer_index: number }[]
  ): string[] {
    // 正答の前に choicesLabel に応じた「選択肢ラベル」を付与して返す
    const correctAnswers = []
    for(const answer of answers) {
      if (choicesLabel === 1) {
        // 1: 原文のまま
        correctAnswers.push(answer["answer"])
      } else {
        // 2: アイウエオ, 3: ABCDE, 4:ⒶⒷⒸ, 5: 12345
        let label = CHOICESLABEL[choicesLabel][answer["answer_index"]]
        correctAnswers.push(label +" "+ answer["answer"])
      }
    }
    return correctAnswers
  }
</script>

<style scoped>

</style>
